
import { supabase } from "@/integrations/supabase/client";
import { ModalCampaign, ModalCampaignQuestion } from "@/types/modalCampaigns";

/**
 * Fetch active campaigns for the current user
 */
export const fetchActiveCampaignsForUser = async (userId: string): Promise<ModalCampaign[]> => {
  const now = new Date().toISOString();

  const { data, error } = await supabase
    .from('modal_campaigns')
    .select(`
      *,
      modal_campaign_users!inner(user_id)
    `)
    .eq('modal_campaign_users.user_id', userId)
    .lte('start_date', now)
    .gte('end_date', now);

  if (error) {
    console.error('Error fetching active campaigns:', error);
    throw error;
  }

  return data as unknown as ModalCampaign[];
};

/**
 * Fetch questions for a campaign
 */
export const fetchCampaignQuestions = async (campaignId: string): Promise<ModalCampaignQuestion[]> => {
  const { data, error } = await supabase
    .from('modal_campaign_questions')
    .select('*')
    .eq('campaign_id', campaignId)
    .order('order_number', { ascending: true });

  if (error) {
    console.error('Error fetching campaign questions:', error);
    throw error;
  }

  return data;
};

/**
 * Get campaign results
 */
export const getCampaignResults = async (campaignId: string): Promise<any[]> => {
  const { data, error } = await supabase
    .from('modal_campaign_user_quiz_results')
    .select('*')
    .eq('campaign_id', campaignId)
    .order('completed_at', { ascending: false });

  if (error) {
    console.error('Error fetching campaign results:', error);
    throw error;
  }

  return data;
};
